import { fetchUserAttributes } from 'aws-amplify/auth'
import { getCurrentUserDetailsRequest } from '@/api/sessionApi'
import { normalizeSessionPayload } from '@/utils/session'
import { loadOrgDetailsIntoStore } from '@/utils/orgDetailsLoader'
import { getApiMessage, isApiSuccess } from '@/mixins/Extras/ApiResponse'
import { handleAuthSessionFailure } from '@/utils/authSessionRecovery'

export async function bootstrapWorkspace(store, { router } = {}) {
  if (store.state.workspaceBootstrapping || store.state.workspaceReady) {
    return { redirected: false, skipped: true }
  }

  store.commit('SET_WORKSPACE_BOOTSTRAPPING', true)
  store.commit('SET_WORKSPACE_BOOTSTRAP_ERROR', '')

  try {
    const attrs = await fetchUserAttributes()
    const cognitoEmail = attrs.email?.trim() || ''

    const raw = await getCurrentUserDetailsRequest()
    if (!isApiSuccess(raw)) {
      const message = getApiMessage(raw, 'Failed to load session.')
      if (await handleAuthSessionFailure(store, message, { router })) {
        return { signedOut: true }
      }
      throw new Error(message)
    }

    const session = normalizeSessionPayload(raw)
    if (!session?.currentUserId || !session?.orgId) {
      throw new Error('Account session is missing organisation context.')
    }

    const userEmail = session.userEmail || cognitoEmail
    if (!userEmail) {
      throw new Error('No email found on your account.')
    }

    store.commit('SET_SESSION', {
      currentUserId: session.currentUserId,
      orgId: session.orgId,
      userEmail,
      emailAddress: session.emailAddress,
      emailChannel: session.emailChannel,
      userName: session.userName,
      userRole: session.userRole,
      organization: session.organization,
    })

    try {
      await loadOrgDetailsIntoStore(store)
    } catch (orgError) {
      console.log('Organisation details bootstrap failed', orgError)
    }

    store.commit('SET_WORKSPACE_READY', true)
    return { redirected: false }
  } catch (error) {
    if (await handleAuthSessionFailure(store, error, { router })) {
      return { signedOut: true }
    }

    const message = error?.message || 'Failed to load workspace.'
    store.commit('SET_WORKSPACE_BOOTSTRAP_ERROR', message)
    return { signedOut: false, error: message }
  } finally {
    store.commit('SET_WORKSPACE_BOOTSTRAPPING', false)
  }
}
